<template>

  <div class="plr16 mt20 mb20">
  
  
   <div class="f-between form-title ">
         <div> <a-button class="col-theme" type="text" @click="get_score_list"><sync-outlined />刷新列表</a-button></div>
         <a-pagination v-model:current="pagenum" :total="scoreCount" @change="change" :defaultPageSize="pagesize" show-less-items />
       </div>

       
     <div class="listBox">
       <a-list item-layout="horizontal" :data-source="scoreList">
         <template #renderItem="{ item }">
           <a-list-item >
               <a-list-item-meta
                
               >
               <template #title>
      
                 <span class="info info_id">{{ item.score_id }} #</span>
                 <span class="info ">用户ID：{{ item.user_id }}</span>
  
                 <span class="info state">{{ item.state }}</span>
                 <span class="info state">{{ item.score }}</span>
                 
               </template>


               <template #description>
                <span class="info ">信息ID：{{ item.info_id }}</span>
                <span class="info ">时间：{{ item.create_time }}</span>

               </template>


              
              
             </a-list-item-meta>
           </a-list-item>
         </template>
       </a-list>
      
           
     </div>


  </div>
</template>



<script>

 import { mapActions } from "vuex"
 import { message } from 'ant-design-vue'
 import config from "@/common/config"

 export default {


   name: "score",
   data() {
     return {
      selected:null,
      pagenum:1,
      pagesize:10,
      scoreList:[],
      scoreCount:0

     }
   },
   created() {
     this.name = localStorage.getItem('name') || '-'
     this.get_score_list()


   }, 
  
   methods: {
     ...mapActions([
         'score_list'
       ]),

     change(page, pageSize){
       this.get_score_list()
     },

  
     get_score_list(){
       let token = localStorage.getItem('t') || 'xx'
       let params = {}
       
       params.token = token
       params.pagenum = this.pagenum
       params.pagesize = this.pagesize

       this.score_list(params)
         .then((dt) => {
           this.scoreList = dt.data
           this.scoreCount = dt.count
           
           
         })
         .catch((dt) => {
           this.$router.replace({
               name: 'login'
             })
           
         });


     }

   }


 };






</script>

<style scoped>

.item{

 height:40px;
 line-height:40px;
}

.width50{

width:50%
}
.devicename{
 width:60%;
 text-overflow: ellipsis; 
 overflow:hidden; 
 white-space: nowrap;
}
.announce{
 cursor: pointer;
 color: yellow;
}
.listBox {
 display: flex;
}
.ant-list {
 flex: 1;
 margin-right: 20px;
}

.info{
 margin: 0 10px;
}

</style>
